<script>
  import { Link } from 'svelte-routing'
  import NavLink from '~/Components/Atoms/NavLink'

  export let callback = null
  export let to = '/'
  export let cta = 'View mentor'
  export let className = null
</script>

{#if callback}
  <NavLink {to} {cta} {className} {callback} />
{:else}
  <Link {to}>
    <NavLink {to} {cta} {className} />
  </Link>
{/if}